import {memo, useMemo} from 'react';
import {forbidExtraProps} from 'airbnb-prop-types';
import {any} from 'prop-types';
import {shuffle} from 'lodash';
import FetchApiProvider from './FetchApiProvider';


export default memo(Layer2);

Layer2.propTypes = forbidExtraProps({
  children: any.isRequired,
});

function Layer2({
  children,
}) {
  return useMemo(
    () => shuffle([
      FetchApiProvider,
    ]).reduce(
      (acc, Provider) => (
        <Provider>
          {acc}
        </Provider>
      ),
      children,
    ),
    [],
  );
}
